export { default as SvgCheck } from './check.svg'
export { default as SvgSearch } from './search.svg'
export { default as SvgOutLink } from './out-link.svg'